import { rawMaterialUrl, normativeUrl } from "../Config/Url";
import axios from "axios";

export const rawMaterialService = {
  get,
};

async function get(tenantId) {
  return axios
    .get(`${rawMaterialUrl}?tenantId=${tenantId}`)
    .then((res) => res)
    .catch((err) => err.response);
}
